<template>
<base-layout pageTitle="Create an Account">

    <div class="mb-6 ">
        <h1 class="text-center"> Create an Account </h1>
        <ion-item>
            <ion-label position="floating" >Phone Number</ion-label>
            <ion-input type="phone" v-model='phone'></ion-input>
        </ion-item>
        <ion-item>
            <ion-label position="floating" >Password</ion-label>
            <ion-input type="password" v-model='password'></ion-input>
        </ion-item>
        <!-- <p class="color-red" v-if="errMsg">{{errMsg}}</p> -->
        <div class="" v-if="errors.length">
            <p class="bg-red-100 p-3 mx-3 mt-3 rounded-lg text-md font-semibold text-red-700" v-for="error in errors" :key="error">{{error}}</p>
        </div>
        <!-- <ion-button class="mt-6 m-2" expand="block" @click="register"> Submit </ion-button> -->
        <div class="mx-2 my-4">
            <button-loading 
            :loading="loadingState" 
            :disabled="loadingState"
            @click="register"> REGISTER </button-loading>
        </div>
    </div>
    <p class="text-center">Alredy have an account?  <router-link :to="{ name:'signIn' }" replace> Login </router-link></p>
</base-layout>
</template>


<script >
import { ref } from 'vue'
import { useRouter } from 'vue-router' // import route
import { IonItem, IonLabel, IonInput, toastController } from '@ionic/vue';
import axios from 'axios'
import ButtonLoading from '../../components/ButtonLoading.vue';
export default {
    components: {
        IonItem, 
        IonLabel, 
        IonInput,
        ButtonLoading,
    },
    setup(){
        const router = useRouter()
        const phone = ref('')
        const password = ref('')
        const loadingState = ref()
        const errors = ref([])

        const clearErrors = () => { errors.value = [] }

        async function openToast() {
            const toast = await toastController
                .create({
                message: '.حساب شما با موفقیت ساخته شد',
                duration: 3000,
                position: 'top',
                color:'success',
                buttons: [
                    {
                    side: 'start',
                    icon: 'star',
                    text: '🎉',
                    handler: () => {
                        console.log('Favorite clicked');
                    }
                    }, {
                    text: 'Done',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                    }
                ]
                })
            return toast.present();
            }


        const register = () => {
            clearErrors()
            if(phone.value === ''){
                errors.value.push("What's your mobile number?")
            }
            if(password.value === ''){
                errors.value.push("Password field is empty.")
            }
            if(!errors.value.length){
                loadingState.value = true
                axios.post('accounts/register/',{
                    phone: phone.value,
                    password: password.value
                    })
                .then((res) => {
                    console.log('successfully registered', res)
                    loadingState.value = false
                    //Redirect to signIn page
                    router.replace('/')
                    openToast()
                })
                .catch(err => {
                    console.log(err)
                    console.log(err.response)
                    for(let item in err.response.data){
                        errors.value.push(`${item}: ${err.response.data[item]}`)
                    }
                    loadingState.value = false
                })
            }
            
          }
        return {
            router,phone,password,register,loadingState,errors
        }

    }
    
}


</script>

<style>

</style>